import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    backgroundColor: semanticColors.background.secondary
  },
  content: {
    flex: 1,
    display: 'flex',
    alignItems: 'stretch',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 0
  },
  devTools: {
    flex: '0 0 416px',
    position: 'relative',
    zIndex: 1,
    backgroundColor: semanticColors.background.primary,
    boxShadow: '0px 2px 8px rgba(0,0,0,0.12)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  footer: {
    flexShrink: 0,
    padding: '16px',
    display: 'flex',
    gap: '8px',
    borderTop: `1px solid ${semanticColors.border.secondary}`
  }
});
